module.exports = __webpack_public_path__ + "r-v3/img/clip.468ac8d2.svg";